export default __webpack_public_path__ + "static/kb_1_3-c75f470cc3183cb489e9c70fd3adfd3e.jpeg";